import React, { useState } from 'react';



const QueryBuilder = ({query, setQuery}) => {

    const [operator, setOperator] = useState("");
    const [showAddMenu, setShowAddMenu] = useState(false);

    const addToQuery = (operation) => {

        if (operator.trim() == "")
            return;

        let updatedQuery = "(" + query + ") " + operation + " (" + operator + ")";

        if (query == "")
            updatedQuery = operator;

        changeQuery(updatedQuery);
        setShowAddMenu(false);
        setOperator("");
    }

    const changeQuery = (query) => {

        setQuery(query);

    }


    const handleClickOptionSelect = () => {

        if (query == "") {
            addToQuery("NOP");
        }
        else {
            setShowAddMenu(!showAddMenu)
        }

    }


    return (<>

        
        <div className="search-container" style={{display: "flex", flexDirection: "row"}}>
            <div style={{flex: 1}}>
                <input type="text" value={operator} onChange={(e) => setOperator(e.target.value)} placeholder="Enter a search term" />
            </div>
            <div style={{ position: 'relative', display: 'inline-block' }}>
                <div className={`query-option-select ${query != "" ? "query-option-select-show-arrow" : null}`} onClick={() => handleClickOptionSelect()}>Add</div>
                {showAddMenu ? <>
                    <div 
                        style={{
                        position: 'absolute',
                        top: '100%',
                        right: 0, 
                        backgroundColor: 'white',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        zIndex: 1000,
                        display: 'flex',
                        flexDirection: 'column',
                        minWidth: '150px'
                        }}
                    >
                        <div className="query-option-row" onClick={() => addToQuery("AND")}>Add as AND</div>
                        <div className="query-option-row" onClick={() => addToQuery("OR")}>Add as OR</div>
                        <div className="query-option-row" onClick={() => addToQuery("NOT")}>Add as NOT</div>
                    </div>
                </> : null}
                    
            </div>
        </div>
        <div style={{ marginTop: "5px" }}>
            <textarea style={{
                width: "100%",
                borderRadius: "4px",
                border: "1px solid #ccc",
                minHeight: "100px"
            }} value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Enter / edit your search query here"></textarea>
        </div>


    </>);


}

export default QueryBuilder;